<template>
    <el-dialog
        :title="$t('zhiji.common.newBusiness')"
        :visible="show"
        :destroy-on-close="true"
        width="600px"
        :close-on-click-modal="false"
        append-to-body
        @close="hide"
    >
        <el-form :model="form" :rules="rules" ref="form" label-width="110px">
            <el-form-item :label="$t('zhiji.common.businessName')" prop="name">
                <el-input v-model="form.name" :placeholder="$t('zhiji.common.inputBusi')" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button round @click="hide" ronud>{{ $i18n.t("ticket.btn.cancel") }}</el-button>
            <el-button type="primary" round @click="submit">{{ $i18n.t("ticket.btn.add") }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
export default {
    name: "AddDialog",
    props: ["show"],
    data() {
        return {
            form: {
                name: ""
            },
            rules: {
                name: [{ required: true, message: this.$t("zhiji.common.inputBusi"), trigger: "blur" }]
            }
        };
    },
    methods: {
        hide() {
            this.$emit("close");
        },
        submit() {
            this.$refs.form.validate(isValid => {
                if (!isValid) {
                    return;
                }
                this.$emit("submit", this.form.name);
            });
        }
    }
};
</script>

<style></style>
